import { captureRemixErrorBoundaryError } from '@sentry/remix';
import { Link, useRouteError, isRouteErrorResponse, MetaFunction } from '@remix-run/react';
import { Layout } from '~/components/Layout';
import { Layout as RootLayout } from '~/root';
import { buttonVariants } from '~/components/ui/button';
import { appendMetaTitleSuffix } from '~/lib/utils/meta';

export const meta: MetaFunction = () => {
  return [
    { title: appendMetaTitleSuffix('エラーが発生しました') },
    { name: 'robots', content: 'noindex' },
  ];
};

const RootErrorBoundary = () => {
  const error = useRouteError();
  captureRemixErrorBoundaryError(error);

  return (
    <>
      <RootLayout title={appendMetaTitleSuffix('エラーが発生しました')} noindex={true}>
        <Layout>
          <div className="p-6 mx-auto flex flex-col items-center justify-center h-screen-justify">
            <div className="text-center font-semibold text-2xl">
              {isRouteErrorResponse(error) ? `${error.status} ${error.statusText}` : 'Error'}
            </div>
            <div className="text-center mt-6">
              <p>
                {isRouteErrorResponse(error) ? error.data : error instanceof Error ? error.message : 'Unknown Error'}
              </p>
              {/* {error instanceof Error && (
                <>
                  <p>The stack trace is:</p>
                  <pre>{error.stack}</pre>
                </>
              )} */}
            </div>
            <div className="text-center mt-6">
              <Link to="/" className={buttonVariants({ variant: 'outline' })}>
                ホームに戻る
              </Link>
            </div>
          </div>
        </Layout>
      </RootLayout>
    </>
  );
};

export default RootErrorBoundary;
